import { ReactElement, useEffect } from 'react';

import { StyledFlex } from '@dreryk/react-components';
import { useFormController } from '@dreryk/react-common';

import { CancelledVisitsVisibilityPreferenceField } from '~libs.shared.appointments-timetable';

import { TimetablePreferencesModalOpener } from '../preferences/TimetablePreferencesModal/TimetablePreferencesModal.opener';

import { VisitsVisibilityPreferences } from './TimetableActions.types';

type TimetableActionsChildrenRenderProps = {
   closeModal: VoidFunction;
};

type TimetableActionsProps = {
   onVisitsVisibilityPreferencesChange: (visitsVisibilityPreferences: VisitsVisibilityPreferences) => void;
   visitsVisibilityPreferencesInitialValues: VisitsVisibilityPreferences;
   children: (renderProps: TimetableActionsChildrenRenderProps) => ReactElement;
};

export const TimetableActions = (props: TimetableActionsProps): ReactElement => {
   const { register, watch } = useFormController<VisitsVisibilityPreferences>(
      props.visitsVisibilityPreferencesInitialValues
   );

   const currentPreferCancelledVisitsVisible = watch('preferCancelledVisitsVisible');

   useEffect(() => {
      props.onVisitsVisibilityPreferencesChange({
         preferCancelledVisitsVisible: currentPreferCancelledVisitsVisible,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentPreferCancelledVisitsVisible]);

   return (
      <StyledFlex gap={'12px'} alignItems={'center'}>
         <TimetablePreferencesModalOpener>{props.children}</TimetablePreferencesModalOpener>
         <CancelledVisitsVisibilityPreferenceField register={register} />
      </StyledFlex>
   );
};
